import { useMutation, useQueryClient } from "react-query";
import {
  cancelTerminalPaymentSession,
  createTerminalPaymentSession,
  createTerminals,
  deleteTerminals,
  retryTerminalPaymentSession,
  updateTerminals,
} from "../../../services/pos-terminals";

export const useCreateTerminals = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createTerminals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
    },
  });
};

export const useUpdateTerminals = (id) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateTerminals({ id: id, data }), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
      queryClient.invalidateQueries([`${id}`, "fetchTerminals"]);
    },
  });
};

export const useDeleteTerminals = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteTerminals(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["fetchTerminals"]);
    },
  });
};

export const useCreateTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    createTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};

export const useRetryTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    retryTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};

export const useCancelTerminalPaymentSession = ({ id = null }) => {
  return useMutation((data) =>
    cancelTerminalPaymentSession({ id, data }).then((res) => res?.data?.data),
  );
};
